import Badge from './Badge';

const statusToneMap: Record<string, 'neutral' | 'primary' | 'accent' | 'primarySolid' | 'accentSolid'> = {
  Taslak: 'neutral',
  Hazırlanıyor: 'neutral',
  Gönderildi: 'primary',
  'Görüşmede': 'accent',
  Revize: 'accent',
  Onaylandı: 'primarySolid',
  Kaybedildi: 'neutral',
  İptal: 'neutral',

  'Devam Ediyor': 'primary',
  Beklemede: 'neutral',
  'Teslimi Yaklaşıyor': 'accent',
  Gecikti: 'accentSolid',
  Tamamlandı: 'primarySolid',

  Yapılacak: 'neutral',
  Kritik: 'accentSolid',
  Önemli: 'accent',
  Normal: 'neutral',

  'Talep Oluşturuldu': 'neutral',
  'Fiyat Bekleniyor': 'accent',
  'Sipariş Verildi': 'primary',
  'Kısmi Geldi': 'accent',
  'Teslim Alındı': 'primarySolid',

  Ödendi: 'primary',
  'Kısmi Ödendi': 'accent',
  Ödenmedi: 'neutral',

  Bloke: 'accentSolid',

  'Yeni Talep': 'primary',
  Planlandı: 'neutral',
  'Müdahale Ediliyor': 'primary',
  'Parça Bekleniyor': 'accent',

  Bekliyor: 'neutral',
  Garanti: 'primary',
  Ücretli: 'neutral',
};

interface StatusBadgeProps {
  status: string;
  className?: string;
}

export default function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const tone = statusToneMap[status] ?? 'neutral';
  return (
    <Badge tone={tone} className={className}>
      {status}
    </Badge>
  );
}